import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import 'react-toastify/dist/ReactToastify.css';

import {
  ApiUrl,
  Axios,
  moment,
  toast,
  Loading,
  DataTablePagination
} from "../../../../../../../../src/components/index";

import { API_URL, API_VERSION } from "../../../../../../../ApiUrl";

const {
  RESTORE_BULK_DOCK,
  SHOW_DELETE_DOCUMENTS
} = ApiUrl;

const Trashtab = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [showpre, setShowPre] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [link, setLink] = useState();
  const [searchPage, setSearchPage] = useState(0);
  const [searchRowsPerPage, setSearchRowsPerPage] = useState(20);
  const [searchTotalCount, setSearchTotalCount] = useState(0);
  const [filterType, setFilterType] = useState("none");
  const docs = [
    {
      uri: link,
    },
  ];

  const fetchDocuments = async () => {
    setLoading(true);
    setError("");
    try {
      let url = SHOW_DELETE_DOCUMENTS;
      if (filterType === "search" && searchTerm) {
        url += `?document_name=${searchTerm}&limit=${searchRowsPerPage}&page=${searchPage + 1}`;
      } else {
        url += `?limit=${rowsPerPage}&page=${page + 1}`;
      }
      const response = await Axios.get(url);
      if (response.data.success) {
        setDocuments(response.data.data || []);
        if (filterType === "search") {
          setSearchTotalCount(response.data.total || 0);
        } else {
          setTotalCount(response.data.total || 0);
        }
      } else {
        setError(response.data.message);
        toast.error(response.data.message);
      }
    } catch (err) {
      setError("No deleted documents found");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchDocuments();
  // }, []);

  // useEffect(() => {
  //   if (filterType === "none") {
  //     fetchDocuments();
  //   }
  // }, [page, rowsPerPage, filterType]);

  // useEffect(() => {
  //   if (filterType === "search" && searchTerm) {
  //     fetchDocuments();
  //   }
  // }, [searchPage, searchRowsPerPage, searchTerm, filterType]);

  useEffect(() => {
  fetchDocuments();
  }, [page, rowsPerPage, searchPage, searchRowsPerPage, searchTerm, filterType]);

  const refresh = () => {
    setSearchTerm("");
    setFilterType("none");
    setSearchPage(0);
    setPage(0);
    fetchDocuments();
  };

  const handleCancelPre = () => {
    setShowPre(false);
  };

  const handleChangePage = (event, newPage) => {
    if (filterType === "search") {
      setSearchPage(newPage);
    } else {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    if (filterType === "search") {
      const newTotalPages = Math.ceil(searchTotalCount / newRowsPerPage) || 1;
      setSearchRowsPerPage(newRowsPerPage);
      setSearchPage(Math.min(searchPage, Math.max(newTotalPages - 1, 0)));
    } else {
      const newTotalPages = Math.ceil(totalCount / newRowsPerPage) || 1;
      setRowsPerPage(newRowsPerPage);
      setPage(Math.min(page, Math.max(newTotalPages - 1, 0)));
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedDocuments((prev) =>
      prev.includes(id) ? prev.filter((docId) => docId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedDocuments.length === documents.length || documents.length === 0) {
      setSelectedDocuments([]);
    } else {
      setSelectedDocuments(documents.map((doc) => doc.id));
    }
  };

  const downloadFile = async (id, name) => {
    console.log(id, name, "case id");
    try {
      const url = `${API_URL}${API_VERSION}/get-file/link/${id}`;
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", name + ".pdf");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const previewFile = async (id) => {
    try {
      const url = `${API_URL}${API_VERSION}/get-file/link/${id}`;
      const response = await fetch(url);
      console.log(response, "response123");
      setLink(response.url);
      const blob = await response.blob();
      const urlObject = window.URL.createObjectURL(blob);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
    setShowPre(true);
  };

  const restoreSelectedFiles = async () => {
    if (selectedDocuments.length === 0) {
      toast.warning("No documents selected for restoration.");
      return;
    }
    try {
      setDisabled(true);
      const response = await Axios.post(RESTORE_BULK_DOCK, { media_ids: selectedDocuments });
      if (response.data.success) {
        toast.success("Selected documents restored successfully!");
        setDocuments((prev) => prev.filter((doc) => !selectedDocuments.includes(doc.id)));
        setTotalCount((prev) => prev - selectedDocuments.length);
        setSelectedDocuments([]);
        // fetchDocuments(page)
        fetchDocuments();
      } else {
        toast.error("Failed to restore selected documents.");
      }
    } catch (error) {
      toast.error("Error restoring selected documents.");
      console.error("Bulk Restore Error:", error);
    } finally {
      setDisabled(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() !== "") {
      setFilterType("search");
      setSearchPage(0);
    } else {
      setFilterType("none");
      setSearchPage(0);
    }
  };

  // const toggleSearchInput = () => {
  //   setShowSearch((prev) => !prev);
  //   if (showSearch && searchTerm) {
  //     setSearchTerm("");
  //     setFilterType("none");
  //     setSearchPage(0);
  //     fetchDocuments();
  //   }
  // };

  const toggleSearchInput = () => {
    setShowSearch((prev) => !prev);
    if (showSearch) {
      // Reset all search-related state and fetch all documents
      setSearchTerm("");
      setFilterType("none");
      setSearchPage(0);
      setPage(0);
      // fetchDocuments();
    }
  };

  return (
    <>
      <div className="wrapper mt-4, mb-3" style={{ backgroundColor: 'white', paddingBottom: '52px' }}>
        <div
          className="ml-4 mr-5 mt-2 listing-main d-md-flex justify-start align-items-center sticky top-0 z-10 bg-gray-800 text-white border border-gray-700 p-1.5 rounded grid grid-cols-2 shadow-lg shadow-black gap-x-2"
          style={{
            position: 'sticky',
            top: '0',
            zIndex: '10',
            backgroundColor: '#FFFFFF',
          }}
        >
          <input
            type="checkbox"
            className="ml-4"
            checked={documents.length > 0 && selectedDocuments.length === documents.length}
            onChange={handleSelectAll}
          />
          <span className="check-po-icon ml-4" onClick={refresh}>
            <i className="zmdi zmdi-refresh-alt"></i>
          </span>

          {showSearch && (
            <div>
              <input
                type="text"
                className="search-input-trash1"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search by Doc name"
              />
              <i
                className="zmdi zmdi-close text-gray-500  cls-btn cursor-pointer absolute right-3 top-1/2 transform -translate-y-1/2"
                style={{ fontSize: '20px', color: 'black', cursor: 'pointer'}}
                onClick={toggleSearchInput}
                // onClick={() => {
                //   setSearchTerm("");
                //   toggleSearchInput();
                //   setFilterType("none");
                //   setSearchPage(0);
                //   fetchDocuments();
                // }}
              />
            </div>
          )}

          <span className="ml-2 mr-1 se12 m-0 p-0" style={{ fontSize: '15px', fontWeight: 'bold' }}>Search</span>

          <span className="search56">
            <i
              className="zmdi zmdi-search text-gray-500 m-0 p-o"
              style={{ fontSize: '23px' }}
              onClick={toggleSearchInput}
            />
          </span>

          <button
            className="btn btn-success ml-5 mt-2 mb-2"
            onClick={restoreSelectedFiles}
            disabled={disabled || selectedDocuments.length === 0}
          >
            Restore Selected
          </button>
        </div>

        <div
          className="pl-4 pr-4 mr-3"
          style={{ maxHeight: 'calc(100vh - 160px)', overflowY: 'auto' }}
        >
          {loading ? (
            <div className="text-center mt-4">
              <Loading />
            </div>
          ) : documents.length > 0 ? (
            <>
              {documents.map(({ id, media, role, deleted_at }) => (
                <div key={id} className="listing-main p-4 mt-3 d-md-flex justify-content-between align-items-center">
                  <input
                    type="checkbox"
                    className="mr-2 mb-1"
                    checked={selectedDocuments.includes(id)}
                    onChange={() => handleCheckboxChange(id)}
                  />
                  <div className="document-d-flex" style={{ flex: 1 }}>
                    <p className="order-name1 mx-2 fixed-doc-tab1 text-capitalize edit-doc-icon-cont">
                      <b>{media?.alt || "--"}</b>
                    </p>
                    <p className="order-name1 fixed-doc-tab1">
                      Uploaded By: <b className="mx-2">{role || "Unknown"}</b>
                    </p>
                    <p className="order-date1 fixed-doc-tab1 edit-doc-icon-cont">
                      <b>{moment(deleted_at).format("DD.MM.YYYY")}</b>
                    </p>

                    <span
                      className="preview-pdf34"
                      onClick={() =>
                        previewFile(media?.hash_id)
                      }
                    >
                      <b> Preview Pdf </b>
                    </span>

                    <p className="order-name1 mx-2">
                      <i
                        className="zmdi zmdi-download"
                        onClick={() =>
                          downloadFile(
                            media?.hash_id,
                            media?.name
                          )
                        }
                        style={{
                          fontSize: "25px",
                          cursor: "pointer",
                        }}
                      ></i>
                    </p>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="text-center mt-5 pb-4 mb-4">No deleted documents found</div>
          )}
        </div>

        <div style={{ marginRight: "36px"}}>
          {documents && documents.length > 0 && (
            <div className="float-right">
              <DataTablePagination
                count={filterType === "search" ? searchTotalCount : totalCount}
                rowsPerPage={filterType === "search" ? searchRowsPerPage : rowsPerPage}
                page={filterType === "search" ? searchPage : page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                rowsPerPageOptions={[20, 50, 100, 200]}
              />
            </div>
          )}
        </div>

      </div>

      <Modal isOpen={showpre} toggle={handleCancelPre}>
        <p className="text-right m-0">
          <span onClick={handleCancelPre} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody>
          <DocViewer
            pluginRenderers={DocViewerRenderers}
            documents={docs}
            style={{ height: "450px" }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Trashtab;